module.exports = __webpack_public_path__ + "img/owl2.84d2899e.svg";